var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.986,
    fill: "#1E0AF5",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.667 9.32V8.153c0-.467 0-.7-.091-.878a.833.833 0 0 0-.364-.364c-.179-.091-.412-.091-.879-.091H7.167c-.467 0-.7 0-.879.09a.833.833 0 0 0-.364.365c-.09.178-.09.411-.09.878v3.167c0 .466 0 .7.09.878.08.157.208.284.364.364.179.091.412.091.879.091h1.166M10 12.236l.833.834 1.875-1.875m-3.041 3.958h3.166c.467 0 .7 0 .879-.09a.833.833 0 0 0 .364-.365c.09-.178.09-.412.09-.878v-3.167c0-.467 0-.7-.09-.878a.833.833 0 0 0-.364-.364c-.179-.091-.412-.091-.879-.091H9.667c-.467 0-.7 0-.879.09a.833.833 0 0 0-.364.365c-.09.178-.09.411-.09.878v3.167c0 .466 0 .7.09.878.08.157.208.284.364.364.179.091.412.091.879.091Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5.986h10v10H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.9fd0ebd26b598039b27aea04050bda70.svg";
export { ForwardRef as ReactComponent };